import { useIntl } from '@cookbook/solid-intl'

import { useConsent } from '../../../contexts/consent-context.jsx'
import { messages } from './cookie-banner.messages.en.js'

/**
 * Controller for the cookie consent banner. Pulls all consent state from
 * `ConsentContext` and exposes the bound action handlers + i18n-formatted
 * strings the JSX needs.
 */
export const useCookieBannerController = () => {
    const intl = useIntl()
    const consent = useConsent()

    return {
        accept: consent.accept,
        decline: consent.decline,
        labels: {
            accept: intl.formatMessage(messages.acceptButton),
            decline: intl.formatMessage(messages.declineButton),
        },
        showBanner: consent.showBanner,
        titleText: intl.formatMessage(messages.title),
    }
}
